// JAZ Sales - Phase 5 (dashboard and reports) strings, merged into the Sales dictionary by salesTranslations.js.
// Arabic and English are equal partners: every key exists in both, and every placeholder ({n}, {name}, ...) appears in
// both languages. Stage, priority, campaign-status, call-result, follow-up / demo / trial-status, onboarding-stage and
// lost-reason names are NOT repeated here: they come from the Phase 2-4 dictionaries.
export const reportsTranslations = {
  ar: {
    // ---- navigation and titles
    nav_reports: 'التقارير',
    dash_title: 'لوحة المبيعات',
    dash_subtitle: 'أرقام العملاء المحتملين ومصادرهم للفترة المحددة.',
    reports_title: 'التقارير',
    reports_subtitle: 'تقارير عملية مبنية على بيانات المبيعات ضمن صلاحياتك.',

    // ---- period
    period_label: 'الفترة',
    range_today: 'اليوم',
    range_this_week: 'هذا الأسبوع',
    range_this_month: 'هذا الشهر',
    range_last_month: 'الشهر الماضي',
    range_custom: 'نطاق مخصص',
    period_from: 'من',
    period_to: 'إلى',
    period_apply: 'تطبيق',
    period_showing: 'تعرض البيانات من {from} إلى {to}',
    period_tz_note: 'التواريخ بتوقيت بغداد (UTC+3).',
    period_error_incomplete: 'حدد تاريخ البداية والنهاية.',
    period_error_reversed: 'تاريخ النهاية لا يسبق تاريخ البداية.',
    period_error_too_long: 'أقصى مدة للفترة {n} يوماً.',
    period_error_generic: 'الفترة المحددة غير صالحة.',

    // ---- scope and freshness
    dash_scope_team: 'بيانات الفريق كاملاً',
    dash_scope_personal: 'بياناتك أنت فقط',
    dash_narrowed: 'مقتصر على: {name}',
    dash_as_of: 'حتى {time}',
    filter_employee: 'الموظف',
    filter_all_employees: 'كل الموظفين',
    dash_error: 'تعذر تحميل لوحة المبيعات',
    dash_nothing: 'لا توجد أقسام متاحة لك في هذه اللوحة.',
    dash_view_board: 'فتح لوحة المسار المباشرة',

    // ---- what a number is based on
    basis_cohort: 'ضمن الفترة',
    basis_event: 'حدث في الفترة',
    basis_now: 'الآن',
    basis_cohort_hint: 'عملاء محتملون أُنشئوا خلال الفترة، حسب مرحلتهم الحالية.',
    basis_event_hint: 'أحداث وقعت خلال الفترة، كل نوع بتاريخه.',
    basis_now_hint: 'قراءة لحظية للوضع الحالي، لا تتأثر بالفترة.',

    // ---- sections
    sec_kpis: 'المؤشرات',
    sec_pipeline: 'مسار المبيعات',
    sec_performance: 'أداء الموظفين',
    sec_sources: 'مصادر العملاء المحتملين',
    sec_campaigns: 'الحملات',
    sec_activity: 'النشاط',
    sec_onboarding: 'التهيئة',
    sec_definitions: 'تعريفات المؤشرات',
    sec_show_definitions: 'عرض التعريفات',
    sec_hide_definitions: 'إخفاء التعريفات',

    // ---- KPIs
    kpi_total_leads: 'إجمالي العملاء المحتملين',
    kpi_new_leads: 'جدد',
    kpi_assigned_leads: 'مُسندون',
    kpi_contacted_leads: 'تم التواصل معهم',
    kpi_interested_leads: 'مهتمون',
    kpi_demos: 'في مرحلة العرض',
    kpi_negotiations: 'قيد التفاوض',
    kpi_won: 'فازوا',
    kpi_lost: 'خسروا',
    kpi_conversion_rate: 'معدل التحويل',
    kpi_active_trials: 'فترات تجريبية نشطة',
    kpi_upcoming_demos: 'عروض قادمة',
    kpi_overdue_followups: 'متابعات متأخرة',
    kpi_upcoming_followups: 'متابعات قادمة',
    kpi_no_data: 'لا بيانات',

    // ---- definitions (one place, shown as tooltips and in the definitions list)
    def_total_leads: 'العملاء المحتملون الذين أُنشئوا خلال الفترة. المؤرشفون غير محسوبين.',
    def_stage: 'من عملاء الفترة، من هم الآن في: {stages}.',
    def_conversion_rate: 'الفائزون ÷ العملاء المحتملون الذين دخلوا الفترة. تظهر «-» إذا لم يدخل أي عميل. العملاء المفتوحون يُحسبون في المقام.',
    def_overdue_followups: 'متابعات معلّقة انتهى موعدها. قراءة لحظية لا تتأثر بالفترة.',
    def_upcoming_followups: 'متابعات معلّقة موعدها الآن أو لاحقاً. قراءة لحظية.',
    def_upcoming_demos: 'عروض مجدولة موعدها الآن أو لاحقاً. قراءة لحظية.',
    def_active_trials: 'فترات تجريبية حالتها نشطة على العملاء المتاحين لك. قراءة لحظية.',
    def_activity: 'مكالمات + متابعات + عروض + فترات تجريبية تقع في الفترة (المكالمة بوقتها، المتابعة بموعدها، العرض بموعده، التجربة ببدايتها). الملغاة غير محسوبة.',
    def_pipeline: 'عدد العملاء المحتملين وقيمتهم التقديرية في كل مرحلة حالية، لعملاء الفترة.',
    def_value: 'القيمة التقديرية يدخلها الموظفون بلا عملة، وتُهمل عند غيابها.',
    def_onboarding: 'التهيئة: النشطة (غير المفعّلة) وتوزيعها حسب المرحلة الحالية قراءة لحظية، والمفعّلة تُحسب بتاريخ التفعيل.',

    // ---- shared table / chart labels
    rc_employee: 'الموظف',
    rc_leads: 'العملاء المحتملون',
    rc_won: 'فاز',
    rc_lost: 'خسر',
    rc_open: 'مفتوح',
    rc_conversion: 'التحويل',
    rc_calls: 'مكالمات',
    rc_followups: 'متابعات',
    rc_demos: 'عروض',
    rc_trials: 'تجارب',
    rc_activities: 'إجمالي النشاط',
    rc_value: 'القيمة التقديرية',
    rc_won_value: 'قيمة الفائزين',
    rc_valued: 'لديها قيمة',
    rc_source: 'المصدر',
    rc_campaign: 'الحملة',
    rc_status: 'الحالة',
    rc_stage: 'المرحلة',
    rc_priority: 'الأولوية',
    rc_created: 'تاريخ الإضافة',
    rc_closed: 'تاريخ الإغلاق',
    rc_assigned: 'المسؤول',
    rc_business: 'النشاط التجاري',
    rc_started: 'بدأت',
    rc_completed: 'اكتملت',
    rc_total: 'الإجمالي',
    rc_active: 'نشطة',
    rc_activated: 'مفعّلة',
    rc_unassigned_row: 'بدون موظف',
    rc_no_campaign: 'بدون حملة',
    rc_more_items: 'يعرض الأكثر نشاطاً: {shown} من {total}',
    rc_view_leads: 'عرض العملاء المحتملين',

    // ---- reports page
    rep_select: 'التقرير',
    rep_name_leads: 'تقرير العملاء المحتملين',
    rep_name_pipeline: 'تقرير المسار',
    rep_name_employees: 'أداء الموظفين',
    rep_name_sources: 'أداء مصادر العملاء',
    rep_name_campaigns: 'أداء الحملات',
    rep_name_conversion: 'تقرير التحويل',
    rep_name_activities: 'تقرير النشاط',
    rep_name_onboarding: 'تقرير التهيئة',
    rep_desc_leads: 'قائمة بالعملاء المحتملين الذين أُنشئوا في الفترة مع إجماليات.',
    rep_desc_pipeline: 'عدد العملاء المحتملين وقيمتهم في كل مرحلة حالية.',
    rep_desc_employees: 'العملاء المحتملون والفوز والتحويل والنشاط لكل موظف.',
    rep_desc_sources: 'العملاء المحتملون والفوز والتحويل لكل مصدر.',
    rep_desc_campaigns: 'العملاء المحتملون والفوز والتحويل لكل حملة.',
    rep_desc_conversion: 'معدل التحويل والصفقات المغلقة وأسباب الخسارة والاتجاه.',
    rep_desc_activities: 'المكالمات والمتابعات والعروض والفترات التجريبية لكل نوع وموظف.',
    rep_desc_onboarding: 'سجلات التهيئة التي بدأت في الفترة حسب المرحلة والموظف.',
    rep_filters: 'المرشحات',
    rep_filter_source: 'المصدر',
    rep_filter_campaign: 'الحملة',
    rep_filter_stage: 'المرحلة',
    rep_filter_priority: 'الأولوية',
    rep_filter_campaign_status: 'حالة الحملة',
    rep_filter_basis: 'أساس العد',
    rep_filter_onb_employee: 'موظف التهيئة',
    rep_basis_created: 'العملاء المُنشأون في الفترة',
    rep_basis_all: 'كل العملاء المتاحين لي مهما كان تاريخهم',
    rep_scope_personal: 'يشمل هذا التقرير بياناتك أنت فقط.',
    rep_scope_team: 'يشمل هذا التقرير بيانات الفريق كاملاً.',
    rep_empty: 'لا توجد بيانات في هذه الفترة.',
    rep_error: 'تعذر تحميل التقرير',
    rep_none_available: 'لا توجد تقارير متاحة لك.',
    rep_total_rows: 'الإجمالي: {n}',
    rep_totals: 'الإجماليات',
    rep_no_campaign_row: 'عملاء بلا حملة',
    rep_conv_cohort: 'العملاء المحتملون الذين دخلوا الفترة',
    rep_conv_closed: 'صفقات أُغلقت في الفترة',
    rep_conv_closed_hint: 'مهما كان تاريخ إنشائها.',
    rep_conv_customers: 'تحولوا إلى عملاء',
    rep_conv_lost_reasons: 'أسباب الخسارة',
    rep_conv_trend: 'الاتجاه',
    rep_conv_bucket_day: 'يومياً',
    rep_conv_bucket_week: 'أسبوعياً (من الاثنين)',
    rep_act_breakdown: 'التفصيل',
    rep_act_cancelled_note: 'المهام الملغاة تظهر في التفصيل ولا تُحسب نشاطاً.',
    rep_onb_by_stage: 'حسب المرحلة الحالية',
    rep_onb_by_owner: 'حسب موظف التهيئة',
    rep_onb_unowned: 'غير مسندة',
    rep_onb_started_in_period: 'سجلات بدأت في الفترة',
    rep_leads_summary: 'الإجمالي: {n} · القيمة التقديرية: {value}',
    rep_legend_leads: 'العملاء المحتملون',
    rep_legend_won: 'فاز',
  },
  en: {
    // ---- navigation and titles
    nav_reports: 'Reports',
    dash_title: 'Sales Dashboard',
    dash_subtitle: 'Lead figures and sources for the selected period.',
    reports_title: 'Reports',
    reports_subtitle: 'Practical reports built on the Sales data you have access to.',

    // ---- period
    period_label: 'Period',
    range_today: 'Today',
    range_this_week: 'This week',
    range_this_month: 'This month',
    range_last_month: 'Last month',
    range_custom: 'Custom range',
    period_from: 'From',
    period_to: 'To',
    period_apply: 'Apply',
    period_showing: 'Showing data from {from} to {to}',
    period_tz_note: 'Dates are in Baghdad time (UTC+3).',
    period_error_incomplete: 'Choose both a start and an end date.',
    period_error_reversed: 'The end date cannot be before the start date.',
    period_error_too_long: 'A period can span at most {n} days.',
    period_error_generic: 'The selected period is not valid.',

    // ---- scope and freshness
    dash_scope_team: 'Team-wide data',
    dash_scope_personal: 'Only your own data',
    dash_narrowed: 'Narrowed to: {name}',
    dash_as_of: 'As of {time}',
    filter_employee: 'Employee',
    filter_all_employees: 'All employees',
    dash_error: 'Could not load the Sales dashboard',
    dash_nothing: 'No sections of this dashboard are available to you.',
    dash_view_board: 'Open the live pipeline board',

    // ---- what a number is based on
    basis_cohort: 'In period',
    basis_event: 'Happened in period',
    basis_now: 'Now',
    basis_cohort_hint: 'Leads created in the period, by their current stage.',
    basis_event_hint: 'Things that happened in the period, each kind by its own date.',
    basis_now_hint: 'A live reading of the current state, not affected by the period.',

    // ---- sections
    sec_kpis: 'Key figures',
    sec_pipeline: 'Pipeline',
    sec_performance: 'Employee performance',
    sec_sources: 'Lead sources',
    sec_campaigns: 'Campaigns',
    sec_activity: 'Activity',
    sec_onboarding: 'Onboarding',
    sec_definitions: 'Metric definitions',
    sec_show_definitions: 'Show definitions',
    sec_hide_definitions: 'Hide definitions',

    // ---- KPIs
    kpi_total_leads: 'Total leads',
    kpi_new_leads: 'New',
    kpi_assigned_leads: 'Assigned',
    kpi_contacted_leads: 'Contacted',
    kpi_interested_leads: 'Interested',
    kpi_demos: 'In a demo stage',
    kpi_negotiations: 'In negotiation',
    kpi_won: 'Won',
    kpi_lost: 'Lost',
    kpi_conversion_rate: 'Conversion rate',
    kpi_active_trials: 'Active trials',
    kpi_upcoming_demos: 'Upcoming demos',
    kpi_overdue_followups: 'Overdue follow-ups',
    kpi_upcoming_followups: 'Upcoming follow-ups',
    kpi_no_data: 'No data',

    // ---- definitions (one place, shown as tooltips and in the definitions list)
    def_total_leads: 'Leads created in the period. Archived leads are not counted.',
    def_stage: 'Of the period\'s leads, the ones now in: {stages}.',
    def_conversion_rate: 'Won ÷ leads that entered the period. Shows "-" when no lead entered. Open leads count in the denominator.',
    def_overdue_followups: 'Pending follow-ups whose due time has passed. A live reading, not affected by the period.',
    def_upcoming_followups: 'Pending follow-ups due now or later. A live reading.',
    def_upcoming_demos: 'Scheduled demos whose time is now or later. A live reading.',
    def_active_trials: 'Trials whose status is active, on the leads you can access. A live reading.',
    def_activity: 'Calls + follow-ups + demos + trials that fall in the period (a call by when it was made, a follow-up or demo by its due time, a trial by its start). Cancelled work is not counted.',
    def_pipeline: 'Leads and their estimated value per current stage, for the period\'s leads.',
    def_value: 'The estimated value is typed in by staff, has no currency and is ignored where empty.',
    def_onboarding: 'Onboarding: active (not yet activated) records and their split by current stage are live readings; activations are counted by the day they happened.',

    // ---- shared table / chart labels
    rc_employee: 'Employee',
    rc_leads: 'Leads',
    rc_won: 'Won',
    rc_lost: 'Lost',
    rc_open: 'Open',
    rc_conversion: 'Conversion',
    rc_calls: 'Calls',
    rc_followups: 'Follow-ups',
    rc_demos: 'Demos',
    rc_trials: 'Trials',
    rc_activities: 'Total activity',
    rc_value: 'Estimated value',
    rc_won_value: 'Won value',
    rc_valued: 'With a value',
    rc_source: 'Source',
    rc_campaign: 'Campaign',
    rc_status: 'Status',
    rc_stage: 'Stage',
    rc_priority: 'Priority',
    rc_created: 'Created',
    rc_closed: 'Closed',
    rc_assigned: 'Owner',
    rc_business: 'Business',
    rc_started: 'Started',
    rc_completed: 'Completed',
    rc_total: 'Total',
    rc_active: 'Active',
    rc_activated: 'Activated',
    rc_unassigned_row: 'No employee',
    rc_no_campaign: 'No campaign',
    rc_more_items: 'Showing the most active: {shown} of {total}',
    rc_view_leads: 'View leads',

    // ---- reports page
    rep_select: 'Report',
    rep_name_leads: 'Lead report',
    rep_name_pipeline: 'Pipeline report',
    rep_name_employees: 'Employee performance',
    rep_name_sources: 'Lead source performance',
    rep_name_campaigns: 'Campaign performance',
    rep_name_conversion: 'Conversion report',
    rep_name_activities: 'Activity report',
    rep_name_onboarding: 'Onboarding report',
    rep_desc_leads: 'The leads created in the period, with totals.',
    rep_desc_pipeline: 'Leads and their value in each current stage.',
    rep_desc_employees: 'Leads, wins, conversion and activity per employee.',
    rep_desc_sources: 'Leads, wins and conversion per source.',
    rep_desc_campaigns: 'Leads, wins and conversion per campaign.',
    rep_desc_conversion: 'Conversion rate, deals closed, lost reasons and the trend.',
    rep_desc_activities: 'Calls, follow-ups, demos and trials per kind and per employee.',
    rep_desc_onboarding: 'Onboarding records that started in the period, by stage and employee.',
    rep_filters: 'Filters',
    rep_filter_source: 'Source',
    rep_filter_campaign: 'Campaign',
    rep_filter_stage: 'Stage',
    rep_filter_priority: 'Priority',
    rep_filter_campaign_status: 'Campaign status',
    rep_filter_basis: 'Counted on',
    rep_filter_onb_employee: 'Onboarding employee',
    rep_basis_created: 'Leads created in the period',
    rep_basis_all: 'Every lead I can access, whenever created',
    rep_scope_personal: 'This report covers your own data only.',
    rep_scope_team: 'This report covers the whole team.',
    rep_empty: 'No data in this period.',
    rep_error: 'Could not load the report',
    rep_none_available: 'No reports are available to you.',
    rep_total_rows: 'Total: {n}',
    rep_totals: 'Totals',
    rep_no_campaign_row: 'Leads without a campaign',
    rep_conv_cohort: 'Leads that entered the period',
    rep_conv_closed: 'Deals closed in the period',
    rep_conv_closed_hint: 'Whenever they were created.',
    rep_conv_customers: 'Became customers',
    rep_conv_lost_reasons: 'Lost reasons',
    rep_conv_trend: 'Trend',
    rep_conv_bucket_day: 'Daily',
    rep_conv_bucket_week: 'Weekly (from Monday)',
    rep_act_breakdown: 'Breakdown',
    rep_act_cancelled_note: 'Cancelled work shows in the breakdown but is not counted as activity.',
    rep_onb_by_stage: 'By current stage',
    rep_onb_by_owner: 'By onboarding employee',
    rep_onb_unowned: 'Unassigned',
    rep_onb_started_in_period: 'Records started in the period',
    rep_leads_summary: 'Total: {n} · Estimated value: {value}',
    rep_legend_leads: 'Leads',
    rep_legend_won: 'Won',
  },
};
